/* global axios */
import ApiClient from './ApiClient';

class ClustersAPI extends ApiClient {
  constructor() {
    super('clusters', { accountScoped: true });
  }

  get({ page = 1, q = '', clusterTypeId } = {}) {
    return axios.get(this.url, { params: { page, q, cluster_type_id: clusterTypeId } });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, { cluster: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { cluster: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new ClustersAPI();
